import { render, staticRenderFns } from "./EditWarehousePage.vue?vue&type=template&id=90fdfbf8&"
import script from "./EditWarehousePage.vue?vue&type=script&lang=js&"
export * from "./EditWarehousePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports